<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
    </button>
</div>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link " aria-current="page" href="../registroprofesores">Registro Profesores</a>
    </li>
    <li class="nav-item">
      <a class="nav-link " aria-current="page" href="../crud-usuario"> Usuario</a>
    </li>
    <li class="nav-item">
      <a class="nav-link " aria-current="page" href="../crear-encuesta">Crear Encuestas</a>
    </li>
    <li class="nav-item">
      <a class="nav-link " aria-current="page" href="../menuReporte">Reportería</a>
    </li>

  </ul>


